<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.receipt">
  <app-popup-header
    title="{{localService.languageContent.receipt.title}} - {{onGetReceiptTypeName()}}"></app-popup-header>
  <div class="modal-body" *ngIf="wrapper" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div class="row" *ngIf="!isConfigurable">
      <div class="col-12">
        <textarea [(ngModel)]="wrapper.v1" style="height: calc(100vh - 255px);"
          placeholder="{{localService.languageContent.receipt.styles_details}}"
          title="{{localService.languageContent.receipt.styles_details}}"></textarea>
      </div>
    </div>
    <div class="row" *ngIf="isConfigurable && !isFixedGeneral">
      <div class="col-12">
        <textarea rows="4" [(ngModel)]="wrapper.v1"
          placeholder="{{localService.languageContent.receipt.styles_details}}"
          title="{{localService.languageContent.receipt.styles_details}}"></textarea>
      </div>
    </div>
    <div class="row" *ngIf="isConfigurable">
      <div class="col-12">
        <textarea style="height: calc(100vh - 355px);" [(ngModel)]="wrapper.v4"
          placeholder="{{localService.languageContent.receipt.html}}"
          title="{{localService.languageContent.receipt.html}}"
          (keydown)="localService.handleTabForTextArea($event)"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary"
      (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
  </div>
</div>